import Inputmask from 'inputmask';

const phoneSelect = {
    init() {
        this.setupEventListeners();
        this.initList('.js__country_list', '.js__flag', '.js__drop_body_country', this.createCountryListItem);
        this.initList('.js__phone_list', '.js__iso', '.js__drop_body_phone', this.createPhoneListItem);
    },

    initList(listSelector, isoSelector, dropSelector, createItemFn) {
        if ($(listSelector).length > 0) {
            this.loadDataAndInitialize(listSelector, isoSelector, dropSelector, createItemFn);
        }
    },

    loadDataAndInitialize(listSelector, isoSelector, dropSelector, createItemFn) {
        const storedData = localStorage.getItem('phoneSelectData');

        if (storedData) {
            const data = JSON.parse(storedData);
            this.initializeWithData(listSelector, isoSelector, dropSelector, createItemFn, data);
        } else {
            this.loadJsonData()
                .then(data => {
                    this.initializeWithData(listSelector, isoSelector, dropSelector, createItemFn, data);

                    localStorage.setItem('phoneSelectData', JSON.stringify(data));
                })
                .catch(error => {
                    console.error('Ошибка:', error);
                });
        }
    },

    loadJsonData() {
        return fetch('/js/countries.json')
            .then(response => response.json());
    },

    createCountryListItem(item) {
        return `
            <li class="country_item js__country_item js__item" data-name="${item.name}" data-iso="${item.iso}" data-mask="${item.mask}" data-href="${item.flag}" data-code="${item.code}">
                <div class="flag"><img alt="${item.name} flag" src="${item.flag}"></div>
                <div class="name">${item.name}</div>
            </li>`;
    },

    createPhoneListItem(item) {
        return `
            <li class="phone_item js__phone_item js__item" data-name="${item.name}" data-iso="${item.iso}" data-mask="${item.mask}" data-code="${item.code}">
                <div class="flag"><img alt="${item.name} flag" src="${item.flag}"></div>
                <div class="iso">${item.iso}</div>
                <div class="code">${item.code}</div>
            </li>`;
    },

    setupEventListeners() {
        $(document).on('click', '.js__phone_item', this.onPhoneItemClick.bind(this));
        $(document).on('click', '.js__drop_phone', this.onDropPhoneClick.bind(this));
        $(document).on('input', '.js__search_select_list', this.onSearchInputChange.bind(this));
        $(document).on('click', '.js__country_item', this.onCountryItemClick.bind(this));
        $(document).on('click', '.js__drop_country', this.onDropCountryClick.bind(this));
    },

    initializeWithData(listSelector, isoSelector, dropSelector, createItemFn, data) {
        const html = data.map(item => createItemFn(item)).join("");
        const list = $(listSelector);
        if (list.find('li').length === 0) {
            list.append(html);
        }
        const iso = $(isoSelector).data('iso').trim();
        $(`${dropSelector} .js__item[data-iso=${iso}]`).trigger('click');
    },

    onPhoneItemClick(event) {
        const phoneItem = $(event.currentTarget);
        const parentBlockPhone = $('.js__phone_select');
        const valueInput = parentBlockPhone.find('.js__phone').val();
        const btn = parentBlockPhone.find('.js__drop_phone');
        const mask = phoneItem.data('mask').split('#').join('9');
        const code = phoneItem.data('code');
        const iso = phoneItem.data('iso').trim();
        const selector = parentBlockPhone.find('.js__phone');

        selector.attr('placeholder', `${mask.split('9').join('_')}`);

        const inputMaskMy = `${mask}`;
        if (valueInput !== "") {
            parentBlockPhone.find('.js__phone').val(`+${valueInput}`.split(code));
        }
        
        parentBlockPhone.find('input.js__phone').attr({ 'data-code': code, 'data-iso': iso });
        new Inputmask(inputMaskMy).mask(selector);
        btn.find('.js__iso').empty().text(iso);
        btn.find('.js__code').empty().text(code);
        this.closeSelect('.js__drop_phone', '.js__phone_select');
    },

    onDropPhoneClick(event) {
        const dropPhone = $(event.currentTarget);
        dropPhone.toggleClass('active');
        const wrapper = dropPhone.closest('.js__phone_select');
        wrapper.find('.js__drop_body_phone').slideToggle();
        wrapper.toggleClass('open');
    },

    onCountryItemClick(event) {
        const countryItem = $(event.currentTarget);
        const parentBlockCountry = $('.js__country_select');
        const btn = parentBlockCountry.find('.js__drop_country');
        const name = countryItem.data('name');
        const href = countryItem.data('href');
        const iso = countryItem.data('iso').trim();

        btn.find('.js__flag').find('img').attr({
            'src': href,
            'alt': name,
        });
        btn.find('.js__name').empty().text(name);
        parentBlockCountry.find('input.js__country').val(name).attr('data-iso', iso);
        this.closeSelect('.js__drop_country', '.js__country_select');
    },

    onDropCountryClick(event) {
        const dropPhone = $(event.currentTarget);
        dropPhone.toggleClass('active');
        const wrapper = dropPhone.closest('.js__country_select');
        wrapper.find('.js__drop_body_country').slideToggle();
        wrapper.toggleClass('open');
    },

    onSearchInputChange(event) {
        const filter = $(event.currentTarget).val().trim().toLowerCase();
        const phoneListItems = $(event.currentTarget).closest('.js__body_search').find('.js__item');
        phoneListItems.each(function () {
            const iso = $(this).data('iso').trim().toLowerCase();
            const name = $(this).data('name').trim().toLowerCase();
            const code = $(this).data('code').trim().toString();
            if (iso.includes(filter) || name.includes(filter) || code.includes(filter)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        if (filter == "") {
            phoneListItems.show();
        }
    },

    closeSelect(selector, wrapper) {
        const dropSelect = $(selector);
        dropSelect.removeClass('active');
        const wrapperNode = dropSelect.closest(wrapper);
        wrapperNode.find('.js__body_search').slideUp();
        wrapperNode.removeClass('open');
    },
};

$(document).ready(function () {
    phoneSelect.init();

    $(window).on('click', function (event) {
        if (!$(event.target).closest('.js__phone_select, .js__country_select').length) {
            phoneSelect.closeSelect('.js__drop_phone', '.js__phone_select');
            phoneSelect.closeSelect('.js__drop_country', '.js__country_select');
        }
    });
});
